import { AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, timer } from 'rxjs';
import { switchMap, map } from 'rxjs';
import { ProfileHttpService } from '../../profiles/services/profile-http.service';

export function existingProfilenameValidator(profileHttpService: ProfileHttpService, product: string): AsyncValidatorFn {
  return (c: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const debounceTime = 500;

    return timer(debounceTime).pipe(
      switchMap(() => {
        return profileHttpService.isNameAvailable(c.value, product).pipe(
          map((result) => {
            const value = result ? null : { profileNameTaken: true };
            return value;
          })
        );
      }));
  };
}
